/* eslint-disable */
export default {
  schedule: 'Agendar reunião',
  prompt: 'Autorizar a RingCentral a aceder às suas informações da conta.',
  saveAsDefault: 'Guardar como predefinição',
} as const;

// @key: @#@"schedule"@#@ @source: @#@"Schedule Meeting"@#@
// @key: @#@"prompt"@#@ @source: @#@"Please authorize RingCentral to access your account information."@#@
// @key: @#@"saveAsDefault"@#@ @source: @#@"Save as default"@#@
